import styled from 'styled-components';
import StyledDatepicker from 'StyledDatepicker.js';
import {Input, Form} from 'global/styles/styles.js';

const S = {};

S.RegisterWizardFormStep2 = styled(Form)` 
  background-color: ${({theme: {$registerFormBackgroundColor}}) => $registerFormBackgroundColor};
  padding: 1.1875rem;
  padding-bottom: 1.3rem;
`;

S.Row = styled.div`
  width: 100%;
`;

S.Button = styled.button`

`;

S.BellIcon = styled.div`
    width: 30px;
    height: 30px;
    margin: 0 auto;
     & svg {
       width: 100%;
        & .a {
            fill: #c62828 !important;
        }
    }
`;

S.InputWrapper = styled.div`
    position: relative;
    padding: 0.625rem 0 0 0;
    width: 100%; 
    margin: 0 auto;

    &.with-select {
        label {
          z-index: 1;
        }
  }

  &.with-checkbox {
    display: flex;
    flex-wrap: wrap;
    
    ${S.Error}{
       width: 100%;
    }  

  ${S.Label} {
        flex: 1;
        font-size: 1.17rem;
        font-weight: 400;
        padding-top: 0;
        color: #787d83;
        display: flex;
        position: relative;
        left: 0;
        cursor: pointer;
        top: 0;
    }
     ${S.Input}{
        position: absolute!important;
        padding: 0!important;
        border: 0!important;
        overflow: hidden;
        z-index: 0;
        left: 3px;
        top: 1px;
        height: 14px;
        width: auto;
     }
    }
`;

S.Input = styled(Input)`
    border: 1px solid ${({theme: {$registerFormInputBorderColor}}) => $registerFormInputBorderColor};
    border-radius: 3px;
    background-color: ${({theme: {$registerFormInputBackgroundColor}}) => $registerFormInputBackgroundColor};
    height: 42px;
    color: ${({theme: {$registerFormInputColor}}) => $registerFormInputColor};
    font-size: 0.875rem;
    box-sizing: border-box;
    width: 100%;
    padding: 0 1.33333rem;

    &:valid {
        & + label {
         color: #D32F2F;
         margin-top: -21px;
         font-size: 0.625rem;
        }
     }

     &:read-only {
        color: rgba(0, 0, 0, 54%);
        & + label {
         color: rgba(0, 0, 0, 54%);
         margin-top: -21px;
         font-size: 0.625rem;
        }
     }

    &:focus {
        outline: 0;
    }

    &.is-valid {
        border: 2px solid rgb(99, 221, 125);

        & + label {
          color: #63dd7d;
        }
    }

    &.has-error {
        border: 2px solid #D32F2F;
    }
`;

S.Label = styled.label`
    pointer-events: none;
    color: rgba(0, 0, 0, 54%);
    text-align: left;
    position: absolute;
    left: 10px;
    top: 24px;
    background-color: ${({theme: {$registerFormLabelBgColor}}) => $registerFormLabelBgColor};
    width: auto;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    font-weight: 500;
    transition: .2s;
`;

S.PreviousButton = styled.button`
    position: absolute;
    top: 0;
    left: 0;
    background: ${({theme: {$registerFormPreviousButtonBgColor}}) => $registerFormPreviousButtonBgColor};
    text-align: center;
    padding: 0 0.6rem;
    box-sizing: border-box;
    border: none;
    width: 1.5rem;
    height: 1.5rem;
`;

S.SubmitButton = styled.button`
    background-color: ${({theme: {$registerFormSubmitButtonBgColor}}) => $registerFormSubmitButtonBgColor};
    color: ${({theme: {$registerFormSubmitButtonColor}}) => $registerFormSubmitButtonColor};
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    border-radius: 3px;
    border: none;
    height: 2.625rem;
    margin-top: 1.125rem;
       &:disabled {
        background: #E1E5E6;
        color: #8F8F8F; 
    }
`;

S.Select = styled.div`
    align-items: stretch;
    display: block;
    width: 100%;

    &:focus {
        outline: green auto 1px;
    }

    & .react-select__menu{
        margin-top: 0;
        z-index: 5;
        
        & .react-select__menu-list{
             padding: 0;
        }
    }

    & .react-select__control {
        border: 1px solid #0000003D;
        border-radius: 3px;
        background-color: #fff;
        height: 42px;
        color: #0000003D;
        font-size: 14px;
        box-sizing: border-box;
        width: 100%;
        padding: 0px .4rem;
        
        & .react-select__dropdown-indicator {
            
        }
        
        & .react-select__indicator-separator {
            display: none;
        }

    }

    ${S.Label} {
     z-index: 5;
    }
    
`;

S.FakeChbox = styled.div`
    position: relative;
    z-index: 3;
    width: 18px;
    height: 18px;
    font-size: 14px;
    border: 1px solid #E8E8E8;
    border-radius: 3px;
    margin-right: .83rem;
    margin-top: 2px;
    flex-shrink: 0;
    pointer-events: none;
    background-color: #fff;
`;

S.CheckMark = styled.span`
    &:after {
        content: '\f00c';
        display:block;
        font-family: FontAwesome;
        position: absolute;
        left: 0;
        top: 0;
        color: #fff;
        font-size: 16px;
    }
`;

S.CheckboxWrapper = styled.div`
    position: relative;
    display: flex;
    padding: 0;
    flex-wrap: wrap;
    margin: 18px 0 0 0;
    padding-left: 0;

    input {
        position: absolute;
        z-index: 0;
        top: 0;
        height: 12px;
        width: auto;
        overflow: hidden;
        padding: 0;
        border-width: 0;

        &:checked {
            & + div {
                background-color: #D32F2F;
                border-color: #D32F2F; 
            }
        }
    }

    label {
        color: ${({theme: {$registerFormLabelColor}}) => $registerFormLabelColor};
        font-size: 0.625rem;
        display: inline;
        text-align: left;
        position: relative;
        left: 0px;
        top: 0px;
        flex: 1 1 0%;
        line-height: 1.7;
        align-self: center;

        a {
            color: ${({theme: {$registerFormLinkColor}}) => $registerFormLinkColor};
            text-decoration: none;
        }

        span {
            :nth-of-type(2) {
                color: #D32F2F;
                font-weight: 700;
            } 
        }
    }
`;

S.Error = styled.div`
    color: #CE0006;
    margin: 0 auto;
    font-size: 10px;
    flex: 1 100%;
`;

S.SubmissionError = styled.div`
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: #CE0006;
    font-size: 1rem;
    padding: .83rem;
    background-color: #fba59f;
    margin-bottom: .5rem;
    text-align: center;
`;

S.HelpBtn = styled.div`
    color: #777D85;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

S.TextToggler = styled.div`
  align-self: flex-end;
`;

S.TextTogglerIcon = styled.i``;

S.FieldWrapper = styled.div`
display: flex;

& :first-child {
    div {
    width: calc(100% - 5px);
    margin-right: 5px;
    }
}

& :nth-child(2) {
   div {
    width: calc(100% - 5px);
    margin-left: 5px;
   }
}
`;

S.DateOfBirth = styled.div`
  display: flex;
  width: 100%;

  & div {
      flex: 1;
      margin-right: 0.625rem;

      &:last-child {
          margin-right: 0;
      }
  }
`;

S.PrevIcon = styled.div`
    width: 16px;
    height: 16px;
     & svg {
     width: 100%;
        & path {
            fill: #000 !important;
        }
    }
`;

S.ModalText = styled.div`
    padding-bottom: 1.25rem;
    padding-top: 0.625rem;
    font-size: 0.8125rem;
    padding: 0.625rem 2.5rem 1.25rem;
    line-height: 1.6;
`;


S.Modal = styled.div`
    z-index: 98;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .confirm-modal-content {
        position: relative;
        z-index: 99;
        top: -110px;
        width: calc(90% - 32px);
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.26) 0px 19px 38px;
        border-radius: 2px;
        padding: 20px 16px;
        height: auto;

        .buttonsWrapper {
            display: flex;
            justify-content: space-between;  
        }
    }
`;

S.ModalButton = styled.button`
    width: 8.875rem;
    height: 2.625rem;
    box-sizing: border-box;
    padding: 0;
    border-radius: 3px;
    border: ${props => props.cancel ? "1px solid #C62828" : "none"};
    color: ${props => props.cancel ? "#C62828" : "#fff"};
    background-color: ${props => props.cancel ? "#fff" : "#C62828"};  
`;

export default S;